import { CompositeModel } from './composite.model';

import { TextModel, JsonTextModel } from '../primitive/text.model';
import { ODataObject } from '../../interfaces/odata-model.interface';

export class QualityCodeModel extends CompositeModel {
    public taskCode: TextModel;
    public chosenOption: TextModel;
    public constructor(taskCode: string, chosenOption: string) {
        super('QualityCodeModel');

        this.taskCode = <TextModel>this.set(new TextModel('TaskCode', taskCode));
        this.chosenOption = <TextModel>this.set(new TextModel('Choose', chosenOption));
    }
}

export class QualityCodeModelFromJson extends QualityCodeModel {
    public constructor(data: JsonQualityCodeModel) {
        super(data.taskCode.value, data.chosenOption.value);
    }
}

export interface ODataQualityCodeOutModel extends ODataObject {
    TaskCode: string;
    Choose: string;
}

export interface JsonQualityCodeModel {
    taskCode: JsonTextModel;
    chosenOption: JsonTextModel;
}
